import { Computer, LocalOffer, Person, Storefront, Loyalty, Inventory, LocalActivity, Forum } from "@mui/icons-material"

const Navigations = [
  {
    label: 'Dashboard',
    icon: <Computer />,
    alertTypes: [],
    path: '/'
  },
  {
    label: 'Product Management',
    icon: <Storefront />,
    alertTypes: [],
    children: [
      {
        label: 'Products',
        icon: <LocalOffer />,
        alertTypes: [],
        path: '/product-management/products'
      }
    ]
  },
  {
    label: 'Order Management',
    icon: <Inventory />,
    alertTypes: ['newOrderAlert'],
    children: [
      {
        label: 'Orders',
        icon: <Inventory />,
        alertTypes: [],
        path: '/order-management/orders'
      },
    ]
  },
  {
    label: 'Sale Management',
    icon: <Inventory />,
    alertTypes: ['flashSaleAlert'],
    path: '/sale-management'
  },
  {
    label: 'Manage Reviews',
    icon: <Inventory />,
    alertTypes: ['reviewRequest'],
    path: '/review-management'
  },
  {
    label: 'Vouchers',
    icon: <LocalActivity />,
    alertTypes: [],
    path: '/vouchers'
  },
  {
    label: 'Transactions',
    icon: <LocalActivity />,
    alertTypes: ['paymentDueReminder', 'paymentNotification'],
    path: '/transactions'
  },
  {
    label: 'Fulfillment',
    icon: <LocalActivity />,
    alertTypes: [],
    children: [
      {
        label: 'Products',
        icon: <Inventory />,
        alertTypes: [],
        path: '/fulfillment/products'
      },
      {
        label: 'Orders',
        icon: <Inventory />,
        alertTypes: [],
        path: '/fulfillment/orders'
      },
    ]
  },
  {
    label: 'Membership Plan',
    icon: <Loyalty />,
    alertTypes: [],
    children: [
      {
        label: 'Activate Membership',
        icon: <Loyalty />,
        alertTypes: [],
        path: '/membership-plan/activate-membership'
      },
      {
        label: 'Update Membership',
        icon: <Loyalty />,
        alertTypes: [],
        path: '/membership-plan/update-membership'
      },
    ]
  },
  {
    label: 'Invoice Management',
    icon: <Inventory />,
    alertTypes: [],
    path: '/invoice-management'
  },
  {
    label: 'Chat',
    icon: <Forum />,
    alertType: ['newChatAlert'],
    path: '/chat'
  },
  {
    label: 'Profile',
    icon: <Person />,
    alertTypes: [],
    path: '/profile'
  },
]

export default Navigations